function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 26.4,
  height: 26.4,
  transform: "translate(0.800293 0.799805)",
  fill: "white",
  fillOpacity: 0.05
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6003 15.0975H7.40029C7.10855 15.0975 6.82877 14.9816 6.62248 14.7753C6.41619 14.569 6.30029 14.2892 6.30029 13.9975C6.30029 13.7057 6.41619 13.4259 6.62248 13.2196C6.82877 13.0134 7.10855 12.8975 7.40029 12.8975H20.6003C20.892 12.8975 21.1718 13.0134 21.3781 13.2196C21.5844 13.4259 21.7003 13.7057 21.7003 13.9975C21.7003 14.2892 21.5844 14.569 21.3781 14.7753C21.1718 14.9816 20.892 15.0975 20.6003 15.0975Z",
  fill: "#001739"
});

var SvgQuantityMinus = function SvgQuantityMinus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuantityMinus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quantity-minus.e5ae9bf6.svg";
export { ForwardRef as ReactComponent };